import { useNavigate } from "react-router-dom";

export const Columns = (
    selectedRows,
    setSelectedRows,
    openModalAdd,
    item
) => {

    const handleCheckboxChange = (row, checked) => {
        if (checked) {
            // Agregar al arreglo si no existe
            if (!selectedRows.some(r => r.id === row.id)) {
                setSelectedRows([...selectedRows, row]);
            }
        } else {
            // Removerlo
            setSelectedRows(selectedRows.filter(r => r.id !== row.id));
        }
    };

    const columns = [
        {
            id: 'description',
            name: 'Description',
            selector: row => `${row.description}`,
        },
        {
            id: 'priority',
            name: 'Priority',
            cell: row => (
                <div className="flex items-center space-x-2">
                    <p>{row.priority}</p>
                </div>
            ),
        },
        {
            id: 'proposed_date',
            name: 'Proposed date',
            selector: row => `${row.proposed_date}`,
        },
        {
            id: 'isd',
            name: 'Recurring',
            selector: row => `This service is ${row.is_recurring ? "Recurring and the milleage recurrent is: " : 'not recurring'} ${row.milleage_recurrent ?? ''}`,
        },
        {
            id: 'select',
            name: item.status?.id != 41 ? '':'Status',
            button: true,
            cell: row => {
                const isChecked = selectedRows.some(r => r.id === row.id);
                return (
                    <div className="flex items-center space-x-2">
                        {item.status?.id != 41 ?
                            <>
                            {console.log(item)}
                                {/* edit button */}
                                <button onClick={() => openModalAdd(row)} className="flex items-center justify-center px-4 py-2 border-r hover:bg-gray-100">
                                    <i className="fas fa-pen text-gray-500"></i>
                                </button>
                                {/* delete button */}
                                {row.status &&
                                    <input
                                        type="checkbox"
                                        className="h-4 w-4 text-blue-600 border-gray-300 rounded"
                                        checked={isChecked}
                                        onChange={e => handleCheckboxChange(row, e.target.checked)}
                                    />
                                }
                            </>
                            :
                            <p>Service order created</p>
                        }
                    </div>

                );
            },
        },
    ];

    return columns;
};
